import React, { forwardRef, ReactNode } from 'react';
import * as RadixToggleGroup from '@radix-ui/react-toggle-group';
import classNames from 'classnames';

import { Typography } from '../Typography';

import styles from './ToggleGroup.module.scss';

export interface IToggleGroupProps extends Omit<RadixToggleGroup.ToggleGroupSingleProps, 'type'> {
    options: {
        value: string;
        label: ReactNode;
    }[];
    size?: 'small' | 'medium';
    error?: boolean;
    fullWidth?: boolean;
}

export const ToggleGroup = forwardRef<HTMLDivElement, IToggleGroupProps>(
    ({ options, size = 'medium', error, className, fullWidth, ...props }, ref) => {
        return (
            <RadixToggleGroup.Root
                type="single"
                ref={ref}
                className={classNames(
                    styles.toggleGroup,
                    styles[`size-${size}`],
                    {
                        [styles['toggleGroup-error']]: !!error,
                        [styles.fullWidth]: !!fullWidth,
                    },
                    className,
                )}
                {...props}
            >
                {options.map(({ value, label }) => (
                    <RadixToggleGroup.Item key={value} value={value} className={styles.item}>
                        <Typography color="inherit" fontWeight="inherit" style={{ lineHeight: 1 }}>
                            {label}
                        </Typography>
                    </RadixToggleGroup.Item>
                ))}
            </RadixToggleGroup.Root>
        );
    },
);
